Methods of communication with the person.
